var MB = 1024 * 1024;
var fileUploadConfig = {
  chunkSize: 128 * MB
};
export default fileUploadConfig;